import { defineStore } from 'pinia'
import { getFeaturesAsync } from '@/api/onlineApi'

export var useFeatureFlagsStore = defineStore('featureFlags', {
  state: () => ({
    flags: {} as Record<string, boolean>,
    loaded: false,
  }),
  actions: {
    async load() {
      if (this.loaded) {
        return
      }
      try {
        this.flags = await getFeaturesAsync()
      } catch {
        this.flags = {}
      }
      this.loaded = true
    },
    isEnabled(name: string) {
      return this.flags[name] === true
    },
  },
})
